import axios from 'axios'

const login = async (userData) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}systemUsers/login`,
      userData,
      {
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )

    if (response.data.status === 'false') {
      const error = {
        message: 'error loging in',
      }
      throw error
    }
    return response.data.data
  } catch (error) {
    throw error
  }
}

export default login
